import moment from 'moment';

export const parseUsers = (users, dealer = '', agency = '') => {
  return users
    .filter((user) => user.agency === agency && user.dealer === dealer)
    .map((user, index) => ({'key': index, 'text': user.username, 'value': user.username}));
};

export const parseAgencies = (agencies, dealer = '') => {
  return agencies
    .filter((agency) => agency.dealerId === dealer)
    .map((agency, index) => ({'text': `${agency.code}-${agency.description}`, 'value': agency.code, 'key': index}));
};

export const parseDealers = (dealers) => {
  return dealers.map((dealer) => ({'text': dealer.name, 'value': dealer.identification}));
};

export const parseProviders = (providers = []) => {
  return providers.map((provider) => ({
    'text': provider.name,
    'value': provider.code,
  }));
};

export const parseOriginWarehousesAllowed = (originWarehousesAllowed = []) => {
  return originWarehousesAllowed.map((item) => ({'value': item.code, 'text': item.description}));
};

export const parseDictionaryWithNumbers = (dictionary) => {
  return Object.keys(dictionary).map((item) => {
    return {'value': parseInt(item, 10), 'text': dictionary[item]};
  });
};

export const parseZones = (zones) => {
  return zones.map((item) => ({'value': item.code, 'text': item.name}));
};

export const parseReasons = (reasons) => {
  return reasons.map((reason) => ({'text': reason.description, 'value': reason.code}));
};

export const parseTransportTypes = (transportTypes) => {
  return transportTypes.map((transportType) => {
    return {'text': transportType.text, 'value': transportType.secondValue};
  });
};

export const parseClients = (clients) => {
  return clients.map((element, index) => {
    return {'key': index, 'text': element.name, 'value': element.identification};
  });
};

export const parseAgenciesValues = (agencies) => {
  return agencies.map((element, index) => {
    return {'key': index, 'text': element.name, 'value': element.code};
  });
};

export const parseDate = (value) => {
  return value ? moment(value).toDate() : null;
};
